import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-global-catalog",
  "use": "icon-soc-global-catalog-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-global-catalog\">\r\n  <!-- ?? Catalog????? -->\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <path d=\"M256 192h384c53 0 96 43 96 96v448c0 53-43 96-96 96H256V192z\" />\r\n    <path d=\"M736 256h64c53 0 96 43 96 96v416c0 53-43 96-96 96H640\" />\r\n    <path d=\"M352 352h256M352 480h256M352 608h160\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-global-catalog.svg
// module id = Qn62
// module chunks = 477